import React, { Component } from 'react'

export default class Footer extends Component {
  // constructor(props){
  //   super(props);
  // }

  render() {
    const style = this.props.style;

    return (

      <div>
        <footer className="main-footer" style={style}>
          <div className="pull-right hidden-xs">
            <strong>Plataforma TreinarSGI</strong> <small>v1.1</small>
          </div>
          <div className="pull-left hidden-xs">
            <strong>© {new Date().getFullYear()}</strong> Todos os direitos reservados
          </div>
        </footer>
      </div>
      
    )
  }
}
